import { useState, useEffect } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import {
  PasteJobPostHeader,
  SetExternalLinkForm,
  WriteRequestForm,
  UnderWritingForm,
} from './';

const JobPostFormStyle = styled('div')(({ theme }) => ({
  maxWidth: 760,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  padding: theme.spacing(3, 0),
}));

export default function PasteJobPosting({ prevForm, jobPost, reload, isEdit, toggleDialog, close }) {
  const [step, setStep] = useState(1);
  const renderMethod = isEdit ? 'edit' : 'step';

  const goStep = (goto) => {
    if (isEdit) return ;
    if (step === 1 && goto === 0) {
      prevForm();
    } else {
      setStep(goto);
    }
  };

  useEffect(() => {
    setStep(1);
  }, [isEdit])

  const STEP_COMPONENT = {
    1: <SetExternalLinkForm jobPost={jobPost} next={reload} />,
    2: <WriteRequestForm jobPost={jobPost} next={toggleDialog} />,
  }

  const EDIT_STEP_COMPONENT = {
    1: <SetExternalLinkForm jobPost={jobPost} next={toggleDialog} />,
  }

  useEffect(() => {
    if (renderMethod === 'step') {
      switch (jobPost?.status) {
        case 'method-paste':
          setStep(1);
          break;
        case 'external-link-set':
          setStep(2);
          break;
        default:
          setStep(null);
          break;
      };
    }
  }, [jobPost]);

  return (
    <JobPostFormStyle>
      <PasteJobPostHeader step={step} isEdit={isEdit} close={close} goStep={goStep} />
      {renderMethod === 'step' && (
        STEP_COMPONENT[step]
      )}
      {renderMethod === 'edit' && (
        EDIT_STEP_COMPONENT[step]
      )}
    </JobPostFormStyle>
  )
}
